<!--
 * @Descripttion: 工牌福利
 * @Author: jschen
 * @Date: 2021-08-29 17:26:02
 * @LastEditors: chenjinsheng
 * @LastEditTime: 2021-11-04 14:09:56
-->
<template>
    <div class="welfare-manage---page">
        <div class="system-box house-table-box">
            <header class="top-header">
                <div class="breadcrumb">
                    <el-breadcrumb separator="/">
                        <el-breadcrumb-item :to="{ path: '/work-portal/user-center' }">
                            <i class="icon-home"></i> 个人中心
                        </el-breadcrumb-item>
                        <el-breadcrumb-item>工牌福利</el-breadcrumb-item>
                    </el-breadcrumb>
                </div>
            </header>
            <div class="tab-center">
                <div>
                    <el-tabs v-model="activeName" @tab-click="handleClick">
                        <el-tab-pane
                            v-for="({ label, value }, index) in typeOptions"
                            :key="index"
                            :label="label"
                            :name="value"
                        ></el-tab-pane>
                    </el-tabs>
                </div>
            </div>
            <div class="tab-content">
                <welfare-card-list ref="welfareList" :tab-id="typeId"></welfare-card-list>
            </div>
        </div>
    </div>
</template>
<script>
import { getBenefitCategorys } from "@/api";
import WelfareList from "./components/welfare-card-list.vue";
export default {
    name: "NameWelfare",
    components: {
        [WelfareList.name]: WelfareList,
    },
    data() {
        return {
            typeId: "",
            activeName: "",
            typeOptions: [],
        };
    },
    mounted() {
        this.getCategoryList();
    },
    activated() {
        this.getCategoryList();
    },
    methods: {
        // 获取福利类别
        async getCategoryList() {
            try {
                const { code, body, message } = await getBenefitCategorys({});
                if (code === "0000") {
                    this.typeOptions = body.map(({ benefitCategoryName, id }) => ({
                        value: id,
                        label: benefitCategoryName,
                    }));
                    this.typeId = this.activeName = this.typeOptions[0].value;
                    this.$refs["welfareList"].getBenefitList(this.typeId);
                } else {
                    this.$message.error(message);
                }
            } catch (err) {
                this.$message.error(err.data.message || "系统错误");
            }
        },
        handleClick({ name: id }) {
            this.typeId = id;
            this.$refs["welfareList"].reset();
            this.$refs["welfareList"].getBenefitList(id);
        },
    },
};
</script>
<style lang="scss" scoped>
@import "./style.scss";
</style>
